// Index files are intended for importing and executing functions and classes only. They should not contain any logic.
/* eslint-disable */
import enquireNow from "./enquireNow";
import readMore from "./readMore";
import toggleAfterPay from "./toggleAfterPay";
import variantPicker from "./variantPicker";
import giftCardValidation from "./giftCardValidation";
import notifyMe from "./notifyMe";
import checkProductAvailability from "./checkProductAvailability";

function index() {
    checkProductAvailability();
    readMore();
    toggleAfterPay();
    enquireNow();
    variantPicker();
    giftCardValidation();
    notifyMe();
}

export default index;
